import React from 'react'
import { observer } from 'mobx-react'
import Icon from 'components/common/Icon'
import { withTranslation } from 'react-i18next'

const SharedMessage = ({ group, t }) => (
  <div className='shared-message'>
    <div className='heading'>
      <span><Icon id='fa-share-alt' /> </span>
      {t('TARGET_GROUP.SHARED_WITH_YOU')}
    </div>
    {group && <p>{group.owner.email}</p>}
  </div>
)

export default withTranslation()(observer(SharedMessage))
